import { createAsyncThunk } from "@reduxjs/toolkit"
import axios, { AxiosError } from "axios"
import { API_URL_FELL } from "config"
import { BulkApplyData } from "lib/types"

export type BulkApplynUpdatePayload = {
    data?: BulkApplyData,
    projectId: number,
    siteId: number,
    siteDesignId: number,
    error?: string
}

export const putBulkApply = createAsyncThunk<BulkApplynUpdatePayload, { projectId: number, siteId: number, siteDesignId: number, bulkApplyData: BulkApplyData, dispatch }, { rejectValue: BulkApplynUpdatePayload }>("bulkapply/putBulkApply",
    async (args, { rejectWithValue }) => {
        try {
            const apiResponse = await axios.put<BulkApplyData>(`${API_URL_FELL()}/project/${args.projectId}/site/${args.siteId}/sitedesign/${args.siteDesignId}/camera/bulkapply`, args.bulkApplyData)
            return {
                data: apiResponse.data,
                projectId: args.projectId,
                siteId: args.siteId,
                siteDesignId: args.siteDesignId
            }
        } catch (err) {
            const error: AxiosError<string> = err;
            return rejectWithValue({
                error: error.message,
                projectId: args.projectId,
                siteId: args.siteId,
                siteDesignId: args.siteDesignId
            })
        }
    })